import { createSlice } from "@reduxjs/toolkit";
import { uiToggleSkin } from "../utils/uiUtils";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    skin: localStorage.getItem("lightMode") ? "light" : "dark",
    menuOpen: false,
    contactOpen: false,
    videoURL: '',
    notification: {},
  },
  reducers: {
    toggleSkin(state) {
      state.skin = state.skin === "dark" ? "light" : "dark";
      uiToggleSkin();
    },
    openVideo( state, action) {
      console.log( state, action);
      state.videoURL = action.payload;
    },
    toggleMenu(state) {
      state.menuOpen = !state.menuOpen;
    },
    toggleContact(state) {
      state.contactOpen = !state.contactOpen;
    },
    hideNotification(state) {
      state.notification = {};
    },
    showNotification(state, action) {
      state.notification = {
        status: action.payload.status,
        title: action.payload.title,
        message: action.payload.message,
      };
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
